// extracted by mini-css-extract-plugin
module.exports = {"inactive":"MenuBehaviour_inactive__821ca","active":"MenuBehaviour_active__0347b"};